import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const StyledWideContainer = styled(WideContainer)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 0 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
    }
`;

export const ComponentWrapper = styled.div<{ isAuth: boolean }>`
    width: 100%;
    position: relative;
    padding-top: ${(props) => props.isAuth ? '232px' : '222px'};
    display: flex;
    flex-direction: column;
    margin: -150px 0 -50px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding-top: ${(props) => props.isAuth ? '232px' : '231px'};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-top: ${(props) => props.isAuth ? '301px' : '195px'};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-top: ${(props) => props.isAuth ? '301px' : '195px'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-top: 155px;
    }

    @media (max-width: 650px) {
        padding-top: 215px;
    }
`;

export const ProductCategory = styled.span`
    color: ${COLORS.TextInfo};
    ${FONTS.XS};
`;

export const ProductTitle = styled.h1`
    color: ${COLORS.TextPrimary};
    ${FONTS.H2};
`;

export const ComponentGrid = styled.div`
    position: relative;
    display: grid;
    width: 100%;
    height: fit-content;
    grid-template-areas: 'slider description'
                        'characteristics  description';
    grid-template-rows: auto 1fr;
    grid-template-columns: 61% auto;
    margin-top: 32px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-columns: 60% auto;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-columns: 52% auto;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-areas:
            'slider'
            'description'
            'characteristics';
        grid-template-rows: auto;
        grid-template-columns: auto;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 24px -16px 0;
        width: calc(100% + 32px);
        padding: 0 0 40px;
    }
`;

export const SliderWrapper = styled.div`
    position: relative;
    grid-area: slider;
    width: 100%;
    height: 100%;
    margin-bottom: 60px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin-bottom: 48px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 28px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 24px;
    }
`;

export const CharacteristicsWrapper = styled.div`
    position: relative;
    grid-area: characteristics;
    width: 100%;
    height: 100%;
    z-index: 2;
    overflow: auto;
`;

export const DescriptionWrapper = styled.div`
    position: relative;
    grid-area: description;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const RoutersContainer = styled.div<{ isBlock?: boolean }>`
    position: relative;
    width: 100%;

    ${({ isBlock }) => isBlock && css`
        display: block;
    `}

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 0 44px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 0 16px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
    }
`;
